<div #cellEditor class="box is-fixed">
  <form [formGroup]="form">
    @if (isTextArea) {
      <fino-textarea formControlName="editableField" [label]="type() | translate"> </fino-textarea>
    } @else if (isCreditorIdInput || isCreditorNameInput) {
      <app-creditor-search
        [form]="form"
        controlName="editableField"
        [byName]="isCreditorNameInput"
        [label]="type() | translate"
        (selected)="handleCreditorResultSelected($event)"
      ></app-creditor-search>
    } @else {
      <fino-input
        [label]="type() | translate"
        [mask]="mask"
        formControlName="editableField"
        class="mr-2"
      >
      </fino-input>
    }
    <div class="is-flex">
      <button fino-button class="is-fullwidth mr-2" icon="Close" (click)="dismiss()"></button>
      <button
        fino-button
        class="is-fullwidth ml-2"
        icon="Check 1"
        [disabled]="form.invalid"
        (click)="confirmField()"
      ></button>
    </div>
  </form>
</div>
